import { activityTypes } from '@rockalingua/shared/activities/constants';

export const ACTIVITY_TYPES = activityTypes;

export const ACTIVITY_TYPES_WITH_LABELS = {
  [ACTIVITY_TYPES.video]: 'Video',
  [ACTIVITY_TYPES.song]: 'Song',
  [ACTIVITY_TYPES.craft]: 'Craft',
  [ACTIVITY_TYPES.pictureDictionary]: 'Picture dictionary',
  [ACTIVITY_TYPES.interactiveVideo]: 'Video with questions',
  [ACTIVITY_TYPES.game]: 'Game',
  [ACTIVITY_TYPES.worksheet]: 'Worksheet',
  [ACTIVITY_TYPES.realTime]: 'Live task',
  [ACTIVITY_TYPES.comic]: 'Comic',
  [ACTIVITY_TYPES.storyWithQuestions]: 'Story with questions',
  [ACTIVITY_TYPES.songQuestions]: 'Song challenge',
  [ACTIVITY_TYPES.reinforcement]: 'Reinforcement',
};

export const ACTIVITIES_ASSETS_FOLDERS = {
  [ACTIVITY_TYPES.video]: 'videos',
  [ACTIVITY_TYPES.song]: 'songs',
  [ACTIVITY_TYPES.craft]: 'crafts',
  [ACTIVITY_TYPES.pictureDictionary]: 'pictureDictionaries',
  [ACTIVITY_TYPES.interactiveVideo]: 'interactiveVideos',
  [ACTIVITY_TYPES.game]: 'games',
  [ACTIVITY_TYPES.worksheet]: 'worksheets',
  [ACTIVITY_TYPES.realTime]: 'realTime',
  [ACTIVITY_TYPES.comic]: 'comics',
  [ACTIVITY_TYPES.storyWithQuestions]: 'storiesWithQuestions',
  [ACTIVITY_TYPES.songQuestions]: 'songQuestions',
  shortStory: 'shortStories',
};
